<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-12">
        <select [(ngModel)]="selectedView" [ngModelOptions]="{standalone: true}" (change)="alternarView()"
          name="selectedView" id="selectedView" style="border: none !important; width: 100px;"
          class="custom-select col-1">
          <option [selected]="view.chave === selectedView.chave" [ngValue]="view" *ngFor="let view of listViews">
            {{view.valor}}
          </option>
        </select>
        <a style="cursor: pointer" (click)="navPrev()" aria-label="Previous" class="ml-5 mr-3">
          <img src="assets/img/global/left-24.png" alt="anterior" height="20" width="20">
        </a>
        <label>{{calendarApi?.view.title}}</label>
        <a style="cursor: pointer" (click)="navNext()" aria-label="Next" class="ml-3">
          <img src="assets/img/global/right-24.png" alt="próximo" height="20" width="20">
        </a>

        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a href="#" (click)="iniciarNovoEvento()" data-toggle="modal" data-target="#dialogImportar"
          *ngIf="podeIncluir()" class="btn btn-sm btn-success float-right mr-5">
          <img src="assets/img/global/plus.png" alt="novo" title="Incluir" height="20" width="20">
          Novo Evento
        </a>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-12">
        <full-calendar #calendar [options]="calendarOptions"></full-calendar>
      </div>
    </div>
  </div>
  <!-- <pre>{{calendarEvents|json}}</pre> -->
</div>

<div class="modal fade" id="dialogEvento" tabindex="-1" role="dialog" aria-labelledby="Evento" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">{{selectedEvent.id ? 'Alterar' : 'Incluir'}} evento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row mb-2">
            <div class="col-12">
              <input #titulo_ autocomplete="off" [(ngModel)]="selectedEvent.title" [ngModelOptions]="{standalone: true}"
                type="text" placeholder="Informe o Título do evento" class="form-control" id="titulo">
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <p-editor id="descricao" [(ngModel)]="selectedEvent.descricao" [ngModelOptions]="{standalone: true}"
                placeholder="Descrição do evento (opcional)" [style]="{'height':'100px'}">
                <p-header>
                  <span class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                    <button class="ql-strike"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-link"></button>
                  </span>
                </p-header>
              </p-editor>
            </div>
          </div>
          <div *ngIf="!selectedEvent.allDay" class="row mb-2">
            <div class="col-6">
              <p-calendar id="inicio" [(ngModel)]="selectedEvent.start" [ngModelOptions]="{standalone: true}"
                placeholder="Ínicio" inputStyleClass="form-control" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }" showTime="true" hourFormat="24"
                dateFormat="dd/mm/yy">
              </p-calendar>
            </div>
            <div class="col-6">
              <p-calendar id="fim" [(ngModel)]="selectedEvent.end" [ngModelOptions]="{standalone: true}"
                placeholder="Fim" inputStyleClass="form-control" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }" showTime="true" hourFormat="24"
                dateFormat="dd/mm/yy">
              </p-calendar>
            </div>
          </div>
          <div *ngIf="selectedEvent.allDay" class="row mb-2">
            <div class="col-6">
              <p-calendar id="inicio" [(ngModel)]="selectedEvent.start" [ngModelOptions]="{standalone: true}"
                placeholder="Ínicio" inputStyleClass="form-control" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }" dateFormat="dd/mm/yy">
              </p-calendar>
            </div>
            <div class="col-6">
              <p-calendar id="fim" [(ngModel)]="selectedEvent.end" [ngModelOptions]="{standalone: true}"
                placeholder="Fim" inputStyleClass="form-control" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }" dateFormat="dd/mm/yy">
              </p-calendar>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-6">
              <div class="checkbox checbox-switch mt-2 switch-primary">
                <label>
                  <input [(ngModel)]="selectedEvent.allDay" [ngModelOptions]="{standalone: true}" type="checkbox" />
                  <span></span>
                  Dia inteiro
                </label>
              </div>
            </div>
            <div class="col-6">
              <select [(ngModel)]="selectedEvent.recorrente" [ngModelOptions]="{standalone: true}" name="recorrente"
                id="recorrente" style="border: none !important" class="custom-select">
                <option [selected]="item.chave === selectedEvent.recorrente" [ngValue]="item.chave"
                  *ngFor="let item of listRecorrentes">
                  {{item.valor}}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-8">
              <p-selectButton id="select-button-agenda" [options]="listCores" [(ngModel)]="selectedEvent.color"
                [ngModelOptions]="{standalone: true}">
                <ng-template let-cor>
                  <span class="tag-cor" [ngStyle]="{'background-color': cor.value}"></span>
                </ng-template>
              </p-selectButton>
            </div>
            <div class="col-4">
              <div *ngIf="selectedEvent.id" class="checkbox checbox-switch switch-success float-left">
                <label>
                  <input [(ngModel)]="selectedEvent.concluido" [ngModelOptions]="{standalone: true}" type="checkbox" />
                  <span></span>
                  Concluído
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer" style="display: inline;">
        <button (click)="salvarEvento()" type="button" class="btn btn-primary btn-sm float-right" id="btnEvento"
          data-dismiss="modal">{{selectedEvent.id ? 'Alterar' : 'Incluir'}} Evento</button>
        <button type="button" class="btn btn-link float-right" id="btnCancelarEvento"
          data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>